<template>
  <v-container id="LitigiosVer" fluid>
    <v-row justify="center">
      <v-col cols="auto">
        <template>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Nueva Acción</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <validation-observer v-slot="{ handleSubmit }">
                    <form id="nuevoSeguimiento" @submit.prevent="handleSubmit(validateForm)">
                      <v-row>
                        <v-col cols="6">
                          <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                                <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                              </validation-provider>
                            </template>
                            <v-date-picker v-model="dataForm.fecha" color="gold" landscape scrollable locale="es-419" no-title @input="menu = false" />
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <base-upload-files folder="/documentaciones/legales" tipo="pdf" :documento-id="dataForm.documento_id" @documento="newFile = $event" />
                        </v-col>
                      </v-row>
                      <v-row align="center" justify="center">
                        <v-col cols="12">
                          <validation-provider v-slot="{ errors }" name="descripción" rules="required|max:191">
                            <v-textarea v-model="dataForm.descripcion_accion" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Descripcion" />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox v-model="dataForm.accion_propia_sn" class="pa-0 ml-0">
                            <span slot="label" class="black--text">
                              Acción propia
                            </span>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </form>
                  </validation-observer>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" text form="nuevoSeguimiento" type="submit">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
      </v-col>
      <v-col cols="auto">
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              ¿Realmente desea eliminar?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeDelete">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="auto">
        <v-dialog v-model="dialogCerrar" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              ¿Realmente desea cerrar el litigio?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeCerrar">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="cerrarPedido">
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row v-if="$can('M_legales_edita')" justify="center">
      <template v-if="!litigio.fecha_cierre">
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark fab color="black" v-bind="attrs" v-on="on" @click="open(true)">
                <v-icon dark large>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Nuevo</span>
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark fab color="black" v-bind="attrs" v-on="on" @click="openCerrar">
                <v-icon dark large>
                  mdi-pin-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Cerrar Litigio</span>
          </v-tooltip>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="auto">
        <v-chip class="ma-2" label color="grey" text-color="white">
          <v-icon left>
            mdi-account
          </v-icon>
          <span style="font-size: 130%">{{ litigio.contraparte_name }}</span>
        </v-chip>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-chip class="ma-2" label color="gold" text-color="white">
          <v-icon left>
            mdi-account
          </v-icon>
          <span style="font-size: 130%">PriSports</span>
        </v-chip>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col>
        <v-timeline align-top>
          <v-timeline-item
            v-for="(seguimiento, i) in seguimientos"
            :key="i" fill-dot large
            :right="checkPropio(seguimiento)"
            :left="!checkPropio(seguimiento)"
            :color="checkPropio(seguimiento)? 'gold' : 'grey'"
          >
            <template>
              <v-card>
                <v-card-title :class="checkPropio(seguimiento)? 'gold' : 'grey'">
                  <v-row>
                    <v-col cols="auto" class="pl-0 white--text">
                      <span style="font-size: 115%">{{ seguimiento.fecha }}</span>
                    </v-col>
                    <v-spacer />
                    <template v-if="$can('M_legales_edita') && !litigio.fecha_cierre && !seguimiento.primerAccion">
                      <v-col cols="auto" class="white--text">
                        <v-tooltip content-class="top" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="white--text" v-bind="attrs" v-on="on" @click.stop="open(false, seguimiento)">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip content-class="top" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="white--text" v-bind="attrs" v-on="on" @click.stop="deleteItem(seguimiento)">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-title>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <template v-if="seguimiento.accion_propia_sn">
                      <v-card-subtitle>
                        Usuario: {{ seguimiento.user.name }}
                      </v-card-subtitle>
                      <v-divider />
                    </template>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-card-text>
                      <div style="font-size: 110%">
                        {{ seguimiento.descripcion_accion }}
                      </div>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-divider />
                    <template v-if="seguimiento.documento_id" class="pb-0">
                      <v-card-actions>
                        <v-btn :color="checkPropio(seguimiento)? 'green darken-1' : 'indigo'" text small @click="openFile(seguimiento.documento_id)">
                          <U>Ver Documento</U>
                          <v-icon small>
                            mdi-paperclip
                          </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </template>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../components/confirm'

  export default {
    components: {
      confirm,
    },
    props: {
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        menu: false,
        dialog: false,
        dialogDelete: false,
        dialogCerrar: false,
        seguimientos: [],
        newFile: null,
        mode: '',
        dataForm: {
          id: '',
          litigio_id: '',
          fecha: '',
          accion_propia_sn: 0,
          descripcion_accion: '',
          documento_id: null,
        },
        litigio: {
          id: '',
          fecha: '',
          propio_sn: '',
          contraparte_user_id: '',
          club_id: '',
          contraparte_otro: '',
          contraparte_contacto: '',
          detalle: '',
          documento_id: '',
          user_id: '',
          contraparte_name: '',
        },
      }
    },
    watch: {
      newFile (val) {
        this.dataForm.documento_id = this.newFile
      },
    },
    created () {
      this.getSeguimientos()
      this.getLitigio()
    },
    methods: {

      getSeguimientos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/seguimiento_litigio/' + this.id }).then(response => { this.seguimientos = response })
      },

      getLitigio: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/litigios_get/' + this.id })
          .then(response => {
            this.litigio = response
            this.dataForm.litigio_id = this.litigio.id
            this.dataForm.fecha = new Date().toJSON().slice(0, 10)
          })
      },

      checkPropio: function (item) {
        if (item.accion_propia_sn) {
          return true
        } else {
          return false
        }
      },

      open (isNew, item = null) {
        if (isNew) {
          this.mode = 'new'
        } else {
          this.mode = 'edit'
          this.dataForm = Object.assign({}, item)
        }
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.dataForm.id = ''
        this.dataForm.fecha = new Date().toJSON().slice(0, 10)
        this.dataForm.accion_propia_sn = 0
        this.dataForm.descripcion_accion = ''
      },

      openCerrar () {
        this.dialogCerrar = true
      },

      closeCerrar () {
        this.dialogCerrar = false
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.dataForm.id = ''
        this.dataForm.fecha = new Date().toJSON().slice(0, 10)
        this.dataForm.accion_propia_sn = 0
        this.dataForm.descripcion_accion = ''
      },

      validateForm (scope) {
        this.saveAccion()
      },

      saveAccion: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/seguimiento_litigio_agregar',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Acción creada'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
        this.getSeguimientos()
        this.close()
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/seguimiento_litigio_delete/' + item.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Acción eliminada'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getSeguimientos()
      },

      cerrarPedido: async function () {
        await this.$http.put('/api/litigio_cerrar/' + this.litigio.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pedido cerrado'] })
          this.$router.push({ name: 'Legales cerrados' })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },

      openFile (internalid) {
        this.downloadDocument(internalid, false)
      },

      downloadDocument (internalid, isPublic) {
        this.$http.get('/api/files/download/' + internalid + '/disk/' + isPublic, { responseType: 'arraybuffer' })
          .then(response => {
            this.downloadFile(response, 'documentacion')
          }, response => {
          },
          )
      },

      downloadFile (response, filename) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' })
        var url = URL.createObjectURL(newBlob)
        var a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()
      },
    },
  }
</script>
